import { styled } from '@mui/system';
import TextField from '@mui/material/TextField';

export const CustomTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px',
    padding: '0',
    '& fieldset': {
      borderWidth: '2px',
    },
    backgroundColor: '#1e1e1e',
  },
  '& .MuiInputBase-root': {
    overflow: 'auto',
  },
  '& .MuiInputBase-input': {
    fontSize: '12px',
    padding: '8px 10px',
    color: '#f0f0f0',
  },
  '& .MuiInputLabel-root': {
    transform: 'translate(5px, 8px) scale(1)',
    fontSize: '10px',
    color: '#f0f0f0',
  },
  '& .MuiInputLabel-shrink': {
    transform: 'translate(5px, -8px) scale(0.9)',
  },
});
